import React, { useEffect } from 'react';
import FadeIn from '../components/ui/FadeIn';

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-44 pb-24 bg-warmWhite min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <FadeIn>
          <h1 className="font-heading text-5xl font-bold mb-12 text-charcoal">Terms of Service</h1>
          
          <div className="prose prose-slate max-w-none space-y-8 text-gray-600 font-light leading-relaxed">
            <section>
              <h2 className="text-2xl font-heading font-semibold text-charcoal mb-4">1. Product Usage</h2>
              <p>SmileVase provides custom wrapped vases intended for floral arrangements. By purchasing our products, you agree to use them for their intended commercial purpose in the floral industry.</p>
            </section>

            <section className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm ring-1 ring-blush/20">
              <h2 className="text-2xl font-heading font-semibold text-charcoal mb-4">2. Refund & Return Policy</h2>
              <p className="mb-4">We want you to be satisfied with your SmileVase purchase. Please review our specific refund conditions below:</p>
              <ul className="list-disc pl-5 space-y-3">
                <li><strong>Refund Availability:</strong> Refunds are available for returned items that are in their original, unused condition.</li>
                <li><strong>Restocking Fee:</strong> A <strong>$3.00 per vase</strong> restocking fee will be deducted from the total refund amount for all returned orders.</li>
                <li><strong>Design Fees:</strong> Any design fees associated with custom wrapping or specialized branding services are <strong>non-refundable</strong>.</li>
                <li><strong>Return Shipping:</strong> Customers are responsible for all costs associated with shipping vases back to SmileVase for a refund. SmileVase does not provide return labels or cover shipping expenses for returns.</li>
                <li><strong>Damaged Goods:</strong> If vases arrive damaged, please contact us at 602-805-5051 within 48 hours of delivery with photos of the damage for a replacement or credit.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-charcoal mb-4">3. Ordering & Payment</h2>
              <p>Minimum order quantity is 4 vases. Orders are processed only after full payment is received via our secure order portal. Tax-exempt status is available for verified resellers who provide a valid certificate.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-charcoal mb-4">4. Shipping</h2>
              <p>Shipping rates are flat-fee based on region and quantity. Delivery times are estimates and may vary based on carrier performance and seasonal demand. West Valley local delivery is available with specific terms outlined in our pricing section.</p>
            </section>
          </div>
        </FadeIn>
      </div>
    </div>
  );
}